import { useCallback } from "react";
import { useMutation } from "@apollo/client";

import { ATTENDANCE_SCAN } from "graphql/mutation/attendance-gql";


const useAttendanceMutationScan = () => {
    const [ scan, { loading, error } ] = useMutation(ATTENDANCE_SCAN);

    const attendanceScan = useCallback((input) => scan({
        variables: {
            input
        }
    }), [ scan ]);

    return {
        attendanceScan,
        loading,
        error
    };
};

export default useAttendanceMutationScan;
